export default __webpack_public_path__ + "static/media/pricing.e3884267.jpg";